export enum ORGANIZATION_TYPE {
  Provider = 0,
  Customer,
  DevPartner,
  DevPortal
}

export const numberToOrgType = (n: number): string => {
  return ORGANIZATION_TYPE[n];
};

export const orgTypeToNumber = (type: string): number | undefined => {
  const entry = Object.entries(ORGANIZATION_TYPE).find(
    ([key, value]) => isNaN(Number(key)) && key === type
  );
  return entry ? (entry[1] as number) : undefined;
};


export enum EditOrgTabs {
  Profile = 1,
  Applications,
}

export type IOrganizationListRowModel = {
  tenantViews: 
  {
    id: string,
    checkbox: boolean;
    displayName: string;
    email: string;
    status: any;
    created: string;
    url: string;
  }[];
  count: number;
};

export type INewOrganizationModel = {
  name: string;
  adminEmail: string;
  displayName: string;
  type: number;
  url?: string;
  locale?: string;
  // isInternalUse?: boolean;  -- DIGPLTF-3534 comment out temporarily
};

export type IOrganizationModel = {
  id?: string | number;
  name: string;
  email: string;
  displayName: string;
  status?: any,
  type: string;
  url: string;
  locale?: string;
  isActivated?: boolean | undefined;
  created?: string;
  enableMFA?: boolean;
  typeMFA?: any;
  // isInternalUse?: boolean;  -- DIGPLTF-3534 comment out temporarily
};
